








import { Component, Vue, Prop } from "vue-property-decorator";
import { addDays, format } from "date-fns";
import locale from "date-fns/locale/ja";

@Component({})
export default class VDatePeriod extends Vue {
  @Prop({ required: true }) date!: Date;
  @Prop({ required: true, type: Number, validator: v => v > 0 }) days!: number;

  get finalDate(): Date {
    return addDays(this.date, this.days - 1);
  }

  format(date: Date): string {
    return format(date, "M/d(E)", { locale });
  }
}
